// Options vendues à part, activées par l'éditeur : l'interface n'affiche RIEN d'une option inactive (ni menu, ni bouton, ni bandeau).
// Le serveur ne cite à chaque rôle que les options qui le concernent ; il refuse de toute façon (403) une fonction inactive.
import { useQuery } from '@tanstack/react-query';
import { api } from './api.ts';

export interface ModulesOrganisation { tarification_avancee?: boolean; marge_cachee?: boolean; bons_intervention?: boolean; ma_gamme?: boolean; contrats_maintenance?: boolean }

export function useModules(): ModulesOrganisation {
  return useModulesEtat().modules;
}

/** Même lecture, avec l'état du chargement (une page d'option attend la réponse avant de conclure « inactive »). */
export function useModulesEtat(): { charge: boolean; modules: ModulesOrganisation } {
  const r = useQuery({ queryKey: ['modules'], queryFn: () => api.get<{ modules: ModulesOrganisation }>('/api/organisation/modules'), staleTime: 60_000 });
  return { charge: !r.isLoading, modules: r.data?.modules ?? {} };
}
